// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"formula": {
		"gatesSweepArea": "(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)*(sqrt(((netLength+windLength+malletasLength+pieDeGalloLength)**2)-(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)**2))))/2)",
		"__cond": {
			"distanceBtWindTips>=20&&distanceBtWindTips<=25": "#ffcdd2",
			"distanceBtWindTips>=60&&distanceBtWindTips<=90": "#ffcdd2",
			"distanceBtWindTips>=32&&distanceBtWindTips<=45": "#c8e6c9",
			"distanceBtWindTips>=46&&distanceBtWindTips<=59": "#fff9c4",
			"distanceBtWindTips>=26&&distanceBtWindTips<=31": "#fff9c4"
		},
		"distanceBtWindTips": "distanceBtWindTips",
		"netOpening": "(distanceBtWindTips/100)*headropeLength",
		"strikeAngle": "asin(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)/(netLength+windLength+malletasLength+pieDeGalloLength))",
		"doorOpening": "((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength",
		"filteredWaterVolume": "(trawlSpeed*0.516)*(((distanceBtWindTips/100)*headropeLength)*verticalNetOpening*0.75)"
	},
	"fields": {
		"headropeLength": {
			"label": "$form_trawl_systems_headrope_length",
			"index": 2,
			"type": "INPUT",
			"inputType": "number",
			"name": "headropeLength",
			"value": 0
		},
		"windLength": {
			"inputType": "number",
			"label": "$form_trawl_systems_bridle_length",
			"index": 3,
			"type": "INPUT",
			"name": "windLength",
			"value": 0
		},
		"malletasLength": {
			"name": "malletasLength",
			"value": 0,
			"index": 4,
			"label": "$form_trawl_systems_sweepline",
			"type": "INPUT",
			"inputType": "number"
		},
		"pieDeGalloLength": {
			"type": "INPUT",
			"label": "$form_trawl_systems_backstrop_length",
			"index": 5,
			"inputType": "number",
			"value": 0,
			"name": "pieDeGalloLength"
		},
		"trawlSpeed": {
			"name": "trawlSpeed",
			"value": 0,
			"inputType": "number",
			"index": 0,
			"label": "$form_trawl_systems_speed",
			"type": "INPUT"
		},
		"netLength": {
			"type": "INPUT",
			"label": "$form_trawl_systems_net_long",
			"index": 1,
			"inputType": "number",
			"value": 0,
			"name": "netLength"
		},
		"distanceBtWindTips": {
			"label": "$form_trawl_systems_headrope_aperture",
			"index": 7,
			"type": "INPUT",
			"range": {
				"max": 90,
				"step": 1,
				"min": 10
			},
			"inputType": "range-bar",
			"name": "distanceBtWindTips",
			"value": 10
		},
		"verticalNetOpening": {
			"index": 6,
			"label": "$form_trawl_systems_vertical_aperture",
			"type": "INPUT",
			"inputType": "number",
			"name": "verticalNetOpening",
			"value": 0
		}
	},
	"hints": {
		"htmlDef": "<div style=\"display: block; margin-bottom: 1rem; font-family: Helvetica; font-size: 20px;\">     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #c8e6c9;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p1}}</span>           </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #fff9c4;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p2}}</span>        </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #ffcdd2;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p3}}<br>        </div>     <p><strong>{{form_trawl_systems_hints_p4}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p5}}</li>     <li>{{form_trawl_systems_hints_p6}}</li>     <li>{{form_trawl_systems_hints_p7}}</li>     <li>{{form_trawl_systems_hints_p8}}</li>     <li>{{form_trawl_systems_hints_p9}}</li>     <li>{{form_trawl_systems_hints_p10}}</li>     <li>{{form_trawl_systems_hints_p11}}</li>     <li>{{form_trawl_systems_hints_p12}}</li>     <li>{{form_trawl_systems_hints_p13}}<br></li>     <br>       </ol>     <p><strong>{{form_trawl_systems_hints_p14}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p15}}</li>     <li>{{form_trawl_systems_hints_p16}}</li>     <li>{{form_trawl_systems_hints_p17}}</li>     <li>{{form_trawl_systems_hints_p18}}</li>     <li>{{form_trawl_systems_hints_p19}}</li>     <li>{{form_trawl_systems_hints_p20}}</li>     <li>{{form_trawl_systems_hints_p21}}</li>     <li>{{form_trawl_systems_hints_p22}}</li>     <li>{{form_trawl_systems_hints_p23}}</li>     </ol> </div>",
		"title": "Crustaceos"
	}
};

export const crustacean = form;
